import {AllShortcutsEnabled} from '@github-ui/code-view-shared/components/AllShortcutsEnabled'
import {useEditPermissions} from '@github-ui/code-view-shared/contexts/EditPermissionsContext'
import {useReposAppPayload} from '@github-ui/code-view-shared/contexts/FilesPageInfoContext'
import {useRefInfo} from '@github-ui/code-view-shared/contexts/RefInfoContext'
import {useReposAnalytics} from '@github-ui/code-view-shared/hooks/use-repos-analytics'
import {useUrlCreator} from '@github-ui/code-view-shared/hooks/use-url-creator'
import {useCurrentRepository} from '@github-ui/current-repository'
import {ActionList} from '@primer/react'

import {useCurrentBlob} from '../../../hooks/CurrentBlob'
import OpenWithActionItems from './OpenWithActionItems'

export default function EditMenuActionItems({
  editAllowed,
  hasOpenWithItem,
}: {
  editAllowed: boolean
  hasOpenWithItem: boolean
}) {
  const payload = useCurrentBlob()
  const {name: refName} = useRefInfo()
  const {canEdit, canEditOnDefaultBranch} = useEditPermissions()
  const {githubDevUrl} = useReposAppPayload()
  const {sendRepoClickEvent} = useReposAnalytics()
  const {getUrl} = useUrlCreator()
  const {defaultBranch} = useCurrentRepository()

  const {
    headerInfo: {ghDesktopPath, onBranch},
  } = payload

  const isOnDefaultBranch = refName === defaultBranch
  const showDefaultBranchEditOption = !!canEditOnDefaultBranch && !isOnDefaultBranch

  return (
    <>
      {editAllowed && (
        <ActionList.Group>
          <ActionList.GroupHeading>Edit file...</ActionList.GroupHeading>
          {showDefaultBranchEditOption ? (
            <ActionList.LinkItem
              onClick={() => sendRepoClickEvent('BLOB_EDIT_DROPDOWN.ON_DEFAULT_BRANCH')}
              href={getUrl({action: 'edit', commitish: defaultBranch})}
            >
              On <code>{defaultBranch}</code> branch
            </ActionList.LinkItem>
          ) : (
            <ActionList.LinkItem
              onClick={() => sendRepoClickEvent('BLOB_EDIT_DROPDOWN.IN_PLACE')}
              href={getUrl({action: 'edit'})}
              data-hotkey="e"
            >
              In place
              <ActionList.TrailingVisual aria-hidden="true">
                <AllShortcutsEnabled>
                  <kbd>e</kbd>
                </AllShortcutsEnabled>
              </ActionList.TrailingVisual>
            </ActionList.LinkItem>
          )}
        </ActionList.Group>
      )}
      {editAllowed && hasOpenWithItem && <ActionList.Divider />}
      {hasOpenWithItem && (
        <OpenWithActionItems
          editEnabled={canEdit}
          githubDevUrl={githubDevUrl}
          ghDesktopPath={ghDesktopPath}
          onBranch={onBranch}
        />
      )}
    </>
  )
}
